import { render } from "./RepeatUnsupportedWarning.vue?vue&type=template&id=179f40a4"
import script from "./RepeatUnsupportedWarning.vue?vue&type=script&lang=js"
export * from "./RepeatUnsupportedWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__